import script from "./DictCodeSelect.vue?vue&type=script&lang=ts&name=DictCodeSelect&setup=true"
export * from "./DictCodeSelect.vue?vue&type=script&lang=ts&name=DictCodeSelect&setup=true"

import "./DictCodeSelect.vue?vue&type=style&index=0&id=12c53556&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c53556"]])

export default __exports__